import BaseInternalApiService from './BaseInternalApiService';

class StatisticsApiService extends BaseInternalApiService {
  constructor() {
    super();
  }

  async getAdminBusinessStatistics() {
    try {
      const axiosInstance = this.getAxiosInstance();
      const response = await axiosInstance.get('/statistics/admin-business');
      return response.data;
    } catch (error) {
      console.error('Error fetching admin business statistics:', error);
      throw error;
    }
  }

  async getStaffStatistics() {
    try {
      const axiosInstance = this.getAxiosInstance();
      const response = await axiosInstance.get('/statistics/staff');
      return response.data;
    } catch (error) {
      console.error('Error fetching staff statistics:', error);
      throw error;
    }
  }

  async getStatisticsByTimeRange(startDate, endDate) {
    try {
      const axiosInstance = this.getAxiosInstance();
      const response = await axiosInstance.get('/statistics/time-range', {
        params: { startDate, endDate }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching statistics by time range:', error);
      throw error;
    }
  }
}

export default new StatisticsApiService(); 